<template>
<div class='wx-login-view login-form'>
  <h1>{{$t('actions.wxlogin.title')}}</h1>
  <el-form ref="login">
    <el-form-item style='margin-bottom: 0;'>
      <div id='login_container' class='login-container'>
        <spinner class='spinner' />
      </div>
    </el-form-item>

    <el-form-item>
      <div class='left'>
        <router-link to='login'>
          {{$t('actions.login.accountlogin')}}
        </router-link>
      </div>
      <div class='right'>
        <router-link to="/register">{{$t('actions.login.register')}}</router-link>&nbsp;|
        <router-link to="password">{{$t('actions.login.password')}}</router-link>
      </div>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import logger from '@/assets/scripts/logger'
import { lazyload } from '@/assets/scripts/lazy-load-module'

export default {
  mounted() {
    let vm = this
    vm.$store.dispatch('user/wxAuth').then(res => {
      lazyload('wxlogin').then(_ => {
        let obj = new window.WxLogin({
          id: 'login_container',
          appid: res.data.appid,
          scope: res.data.scope,
          state: res.data.state,
          redirect_uri: res.data.redirect_uri,
          href: `//${process.env.HOST}/static/stylesheets/wxlogin.css`
        })
        logger.debug(obj)
      })
    })
  }
}
</script>
<style lang='scss' scoped>
.wx-login-view {
    h1 {
        margin-bottom: 0;
    }

    .spinner {
        top: 100px;
    }

    .login-container {
        height: 380px;
    }
}
</style>



// WEBPACK FOOTER //
// wxlogin.view.vue?5b11de9e